var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleOutlookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "information-circle",
    d: "M64,56a8,8,0,1,0,8,8A8.009,8.009,0,0,0,64,56Zm0,3.28a1.04,1.04,0,1,1-1.04,1.04A1.04,1.04,0,0,1,64,59.28Zm1.92,9.04H62.4a.64.64,0,0,1,0-1.28h1.12V63.52h-.64a.64.64,0,1,1,0-1.28h1.28a.64.64,0,0,1,.64.64v4.16h1.12a.64.64,0,0,1,0,1.28Z",
    transform: "translate(-56 -56)",
    fill: "#6d7077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleOutlookIcon);
export default __webpack_public_path__ + "static/media/info-circle-outlook-icon.04c7d8af8f533ec853a37e4d123ae3f9.svg";
export { ForwardRef as ReactComponent };